<template>
  <div class="digit-input-container">
    <input type="text" ref="digitInput" @input="inputFunc($event.target)" @focus="onFocus" @blur="onBlur" :style="theme" :placeholder="placeholder">
  </div>
</template>

<script>
export default _extend({
  name: 'DigitInputBox',
  props: {
    maxInputLength: {
      type: Number,
      default: 12
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      report_code: '',
      status: 'normal'
    };
  },
  methods: {
    handleClick() {},
    inputFunc(target) {
      const num = target.value.toString().replace(/[\W]/g, '');
      const code = num.replace(/\s/g, '');
      const inputValue = code.replace(/(\d{4})(?=\d)/g, '$1 ');
      this.$emit('inputChange', code);
      if (this.status !== 'normal' && this.report_code.length !== this.maxInputLength) {
        this.status = 'normal';
      }
      if (code.length < this.maxInputLength) {
        this.report_code = code;
        target.value = inputValue;
        setTimeout(() => {
          const len = target.value.length;
          target.setSelectionRange(len, len);
        }, 20);
      } else if (code.length === this.maxInputLength) {
        this.report_code = code;
        target.value = this.report_code.replace(/(\d{4})(?=\d)/g, '$1 ');
      } else if (code.length > 0) {
        target.value = this.report_code.replace(/(\d{4})(?=\d)/g, '$1 ');
      } else {
        target.value = ' ';
        this.setFocus();
      }
    },
    toggle(status) {
      this.status = status;
    },
    clear() {
      this.$refs.digitInput.value = '';
    },
    onFocus(e) {
      this.$refs.digitInput.placeholder = '';
      this.setFocus();
    },
    onBlur(e) {
      this.$refs.digitInput.placeholder = this.placeholder;
    },
    setFocus() {
      const el = this.$refs.digitInput;
      el.focus();
      let range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      let sel = window.getSelection();
      // 判断光标位置，如不需要可删除
      if (sel.anchorOffset !== 0) {
        return;
      };
      sel.removeAllRanges();
      sel.addRange(range);
    },
  },
  computed: {
    theme() {
      window.console.log('input-this.status', this.status);
      let wordColor = '';
      let bgColor = '';
      if (this.status === 'normal') {
        bgColor = '#F5F6F9';
        wordColor = '#4981f2';
      } else {
        bgColor = '#FFF5F5';
        wordColor = '#F66E6A';
      }
      return {
        backgroundColor: bgColor,
        color: wordColor
      };
    }
  }
});
</script>

<style lang="scss" scoped>
@import './DigitInputBox.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/Main/DigitInputBox/DigitInputBox.vue